import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchLicenseEnumData } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class LicenseTypesTypeahead extends Component {
    static propTypes = {
        fetchLicenseEnumData: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        isClearable: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        value: [],
        isClearable: true,
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchLicenseEnumData(LicenseTypesTypeahead.name, 'licenseTypes');
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { suggestions, isRequired, isDisabledGroup, value, error, t } = this.props;
        const currentState = value;
        let currentSuggestions = [];

        if (value && isDisabledGroup) {

            const isCompanyType = currentState.length ? currentState.some(el => el.id === 3) : false;

            currentSuggestions = suggestions.map(el => {
                if (!isCompanyType) {
                    return el.id === 3 ? { ...el, isDisabled: true } : el;
                } else {
                    return { ...el, isDisabled: true };
                }
            });

        } else {
            currentSuggestions = suggestions;
        }

        const options = currentSuggestions.map(licenseType =>
            ({ label: licenseType.name,
                id: licenseType.id,
                isDisabled: isDisabledGroup ? licenseType?.isDisabled : false }));

        return (
            <MultiTypeahead
                options={options}
                isMulti
                isLoading={this.state.isLoading}
                value={value}
                titleId="licenseTypes"
                animatedPlaceholder
                onChangeSuggestion={this.props.onChangeSuggestion}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={error}
                isClearable={this.props.isClearable}
                disabled={this.props.disabled}
                isRequired={isRequired}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === LicenseTypesTypeahead.name
            ? typeahead.list
            : LicenseTypesTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchLicenseEnumData,
    clearTypeahed
})(LicenseTypesTypeahead);
